// extracted by mini-css-extract-plugin
export var carouselTestimonial = "Testimonials-module--carouselTestimonial--Kn9MU";
export var carouselTestimonialItem = "Testimonials-module--carouselTestimonialItem--hvplu";
export var column = "Testimonials-module--column--xNHHT";
export var divider = "Testimonials-module--divider--zC+aQ";
export var item = "Testimonials-module--item--bxMvH";
export var root = "Testimonials-module--root--P1FpE";